import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PaymentCard } from '@shared/models/payment-card';
import { API_DELETE_SAVED_CARDS, API_GET_SAVED_CARDS, HttpService } from 'thkee-common';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private http: HttpService, private store: Store) {}

  load() {
    return this.http.get<PaymentCard[]>(API_GET_SAVED_CARDS);
    // return this.store.select(selectPaymentCards).pipe(
    //   take(1),
    //   switchMap((cards) => {
    //     if (cards) {
    //       return of(cards);
    //     }

    //     return this.http.get<PaymentCard[]>(API_GET_SAVED_CARDS);
    //   })
    // );
  }

  removePaymentMethod(paymentMethodId: string) {
    return this.http.delete(API_DELETE_SAVED_CARDS.replace('<CARD_ID>', paymentMethodId));
  }
}
